import * as React from "react";
import FormikAutocompleteField from "../../formik/FormikAutocomplete";
import PropTypes from "prop-types";
import { HttpClientConfig } from "../../../utils/HttpClient";

export const OrganizationTypeAutocomplete = (props) => {
  const lookupUrl = `${HttpClientConfig.baseURL}/OrganizationType/Lookup`;
  const lookupByIdUrl = `${HttpClientConfig.baseURL}/OrganizationType/LookupById`;

  const handleAddClick = (e) => {
    console.log(e);
  }

  return (
    <FormikAutocompleteField {...props} lookupUrl={lookupUrl} lookupByIdUrl={lookupByIdUrl} onAddButtonClick={handleAddClick} />
  );
};

OrganizationTypeAutocomplete.propTypes = {
  fieldName: PropTypes.string,
  label: PropTypes.string,
  formik: PropTypes.any
}

export default OrganizationTypeAutocomplete;
